export const navigateTo = (path: string) => ({
  type: 'navigateTo',
  payload: path,
});